module.exports = __webpack_public_path__ + "img/UserIndicar_Símbolo_2.632f76d7.png";